"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateCheckDataIncidentInput = void 0;
const class_validator_1 = require("class-validator");
const incident_type_enum_1 = require("../enums/incident-type.enum");
const check_data_incident_sub_type_enum_1 = require("../enums/check-data-incident-sub-type.enum");
class CreateCheckDataIncidentInput {
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsIn)(Object.values([incident_type_enum_1.INCIDENT_TYPE.CHECK_DATA])),
    __metadata("design:type", Object)
], CreateCheckDataIncidentInput.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateCheckDataIncidentInput.prototype, "tripKey", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsIn)([
        check_data_incident_sub_type_enum_1.CHECK_DATA_INCIDENT_SUB_TYPE.CONFLICTING_TRANSPORT_ADDRESS,
        check_data_incident_sub_type_enum_1.CHECK_DATA_INCIDENT_SUB_TYPE.CONFLICTING_TRANSPORT_TYPE,
        check_data_incident_sub_type_enum_1.CHECK_DATA_INCIDENT_SUB_TYPE.IMPRECISE_START_ADDRESS,
        check_data_incident_sub_type_enum_1.CHECK_DATA_INCIDENT_SUB_TYPE.INVALID_TRANSPORT_DELAY,
        check_data_incident_sub_type_enum_1.CHECK_DATA_INCIDENT_SUB_TYPE.TRANSPORT_NOT_FOUND,
    ]),
    __metadata("design:type", Object)
], CreateCheckDataIncidentInput.prototype, "subType", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], CreateCheckDataIncidentInput.prototype, "departureAt", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateCheckDataIncidentInput.prototype, "department", void 0);
exports.CreateCheckDataIncidentInput = CreateCheckDataIncidentInput;
